module.exports = __webpack_public_path__ + "media/images/logo-black-9b33579bce2011495f6c0a8ebb509ef0.svg";